export const RELATIONSHIP_REGISTRY = {
  initiative: [
    {
      key: "related_goals",
      label: "Which objectives does this initiative support?",
      direction: "outgoing",
      relatedEntityTypes: ["objective"],
      relationshipTypes: ["supports"],
      icon: "🎯",
    },
    {
      key: "organization_owns_initiative_reverse",
      label: "Which Organization(s) owns this initiative?",
      direction: "either",
      relatedEntityTypes: ["organization"],
      relationshipTypes: ["owns", "owned by", "is owned by", "ownership"],
      icon: "🏢",
    },
    {
      key: "related_business_capabilities",
      label: "Which business capabilities does this initiative improve?",
      direction: "outgoing",
      relatedEntityTypes: ["business-capability"],
      relationshipTypes: ["improves", "supports", "enables"],
      icon: "💪",
    },
    {
      key: "related_business_contexts",
      label: "Which business contexts does this initiative affect?",
      direction: "outgoing",
      relatedEntityTypes: ["business-context"],
      relationshipTypes: ["affects", "associated_with", "linked"],
      icon: "🏛️",
    },
    {
      key: "related_applications",
      label: "Which applications does this initiative affect?",
      direction: "outgoing",
      relatedEntityTypes: ["application"],
      relationshipTypes: ["affects", "realizes", "builds", "uses"],
      icon: "💻",
    },
    {
      key: "related_data_objects",
      label: "Which data objects does this initiative affect?",
      direction: "outgoing",
      relatedEntityTypes: ["data-object"],
      relationshipTypes: [
        "affects",
        "creates",
        "reads",
        "writes",
        "updates",
        "deletes",
        "transfers",
        "accesses",
      ],
      icon: "💾",
    },
    {
      key: "interface_affected_by_initiative_reverse",
      label: "Which interface(s) does this initiative affect?",
      direction: "outgoing",
      relatedEntityTypes: ["interface"],
      relationshipTypes: ["affects", "impacts"],
      icon: "🔌",
    },
    {
      key: "related_it_components",
      label: "Which technology components does this initiative affect?",
      direction: "outgoing",
      relatedEntityTypes: ["technology-component"],
      relationshipTypes: ["affects", "uses", "implements"],
      icon: "🔧",
    },
    {
      key: "provider_supports_initiative_reverse",
      label: "Which Provider(s) supports this initiative?",
      direction: "incoming",
      relatedEntityTypes: ["provider"],
      relationshipTypes: ["supports", "provides", "serves"],
      icon: "🚚",
    },
  ],
  application: [
    {
      key: "organization_uses_application_reverse",
      label: "Which organizations use this application?",
      direction: "incoming",
      relatedEntityTypes: ["organization"],
      relationshipTypes: [
        "uses",
        "utilizes",
        "consumes",
        "organization uses application",
      ],
      icon: "🏢",
    },
    {
      key: "related_business_capabilities",
      label: "Which business capabilities does this application support?",
      direction: "outgoing",
      relatedEntityTypes: ["business-capability"],
      relationshipTypes: [
        "supports",
        "enables",
        "application supports business-capability",
      ],
      icon: "💪",
    },
    {
      key: "related_business_contexts",
      label: "Which business context(s) does this application support?",
      direction: "outgoing",
      relatedEntityTypes: ["business-context"],
      relationshipTypes: [
        "supports",
        "enables",
        "linked",
        "associated_with",
        "application supports business-context",
      ],
      icon: "🏛️",
    },
    {
      key: "initiative_affects_application_reverse",
      label: "Which initiatives affect this application?",
      direction: "incoming",
      relatedEntityTypes: ["initiative"],
      relationshipTypes: [
        "affects",
        "impacts",
        "realizes",
        "builds",
        "initiative affects application",
      ],
      icon: "🚀",
    },
    {
      key: "platform_runs_application_reverse",
      label: "Which platforms run this application?",
      direction: "incoming",
      relatedEntityTypes: ["platform"],
      relationshipTypes: ["runs", "application runs on platform", "runs on platform"],
      icon: "🏗️",
    },
    {
      key: "related_data_objects",
      label: "Which data objects does this application access?",
      direction: "outgoing",
      relatedEntityTypes: ["data-object"],
      relationshipTypes: [
        "reads",
        "writes",
        "creates",
        "updates",
        "deletes",
        "accesses",
        "CRUD",  // Include CRUD as a valid relationship type
      ],
      icon: "💾",
    },
    {
      key: "related_it_components",
      label: "Which technology components does this application use?",
      direction: "outgoing",
      relatedEntityTypes: ["technology-component"],
      relationshipTypes: ["uses", "runs on", "depends on"],
      icon: "🔧",
    },
    {
      key: "provided_interfaces",
      label: "Which interfaces does this application provide?",
      direction: "outgoing",
      relatedEntityTypes: ["interface"],
      relationshipTypes: ["provides", "exposes"],
      icon: "📤",
    },
    {
      key: "consumed_interfaces",
      label: "Which interfaces are consumed by this application?",
      direction: "incoming",
      relatedEntityTypes: ["interface", "application"],
      relationshipTypes: [
        "consumes",
        "utilizes",
        "consumes from",
        "consumes service from",
      ],
      icon: "📥",
    },
  ],
  interface: [
    {
      key: "interface_provided_by_app",
      label: "Which application provides this interface?",
      direction: "incoming",
      relatedEntityTypes: ["application"],
      relationshipTypes: ["provides", "exposes"],
    },
    {
      key: "interface_consumed_by_app",
      label: "Which applications consume this interface?",
      direction: "incoming",
      relatedEntityTypes: ["application"],
      relationshipTypes: ["consumes", "utilizes"],
    },
    {
      key: "interface_transfers_data",
      label: "Which data objects are transferred by this interface?",
      direction: "outgoing",
      relatedEntityTypes: ["data-object"],
      relationshipTypes: [
        "transfers",
        "accesses",
        "reads",
        "writes",
        "creates",
        "updates",
        "deletes",
      ],
    },
    {
      key: "technology_component_used_by_interface",
      label: "With which IT components is this interface implemented?",
      direction: "outgoing",
      relatedEntityTypes: ["technology-component"],
      relationshipTypes: ["implements", "uses"],
    },
    {
      key: "interface_affected_by_initiative",
      label: "Which initiatives affect this interface?",
      direction: "incoming",
      relatedEntityTypes: ["initiative"],
      relationshipTypes: ["affects", "impacts"],
    },
  ],
  "data-object": [
    {
      key: "data_object_transferred_by_interface",
      label: "Which interfaces transfer this data object?",
      direction: "incoming",
      relatedEntityTypes: ["interface"],
      relationshipTypes: [
        "transfers",
        "accesses",
        "reads",
        "writes",
        "creates",
        "updates",
        "deletes",
      ],
    },
    {
      key: "data_object_affected_by_initiative",
      label: "Which initiatives affect this data object?",
      direction: "incoming",
      relatedEntityTypes: ["initiative"],
      relationshipTypes: ["affects"],
    },
    {
      key: "data_object_crud_by_application",
      label:
        "Which applications are creating, modifying, or deleting this data object?",
      direction: "incoming",
      relatedEntityTypes: ["application"],
      relationshipTypes: ["creates", "reads", "writes", "updates", "deletes", "CRUD"],
    },
  ],
  "technology-component": [
    {
      key: "technology_component_implements_platform",
      label: "Which platforms does this technology component implement?",
      direction: "outgoing",
      relatedEntityTypes: ["platform"],
      relationshipTypes: ["implements"],
      icon: "🏗️",
    },
    {
      key: "technology_component_owned_by_organization",
      label: "Which organizations own this technology component?",
      direction: "incoming",
      relatedEntityTypes: ["organization"],
      relationshipTypes: ["owns"],
      icon: "🏢",
    },
    {
      key: "technology_component_affected_by_initiative",
      label: "Which initiatives affect this technology component?",
      direction: "incoming",
      relatedEntityTypes: ["initiative"],
      relationshipTypes: ["affects", "impacts", "realizes", "builds"],
    },
    {
      key: "it_provided_by_provider_reverse",
      label: "Which providers offer this technology component?",
      direction: "either",
      relatedEntityTypes: ["provider"],
      relationshipTypes: [
        "provides",
        "offers",
        "supplies",
        "owns",
        "ownership",
      ],
    },
    {
      key: "technology_component_used_by_application",
      label: "Which applications are using this IT component?",
      direction: "incoming",
      relatedEntityTypes: ["application"],
      relationshipTypes: ["uses", "runs on", "depends on"],
    },
    {
      key: "technology_component_used_by_interface",
      label: "Which interfaces are implemented using this IT component?",
      direction: "incoming",
      relatedEntityTypes: ["interface"],
      relationshipTypes: ["implements", "uses"],
    },
  ],
  organization: [
    {
      key: "technology_component_owned_by_organization",
      label: "What technology components does this own?",
      direction: "either",
      relatedEntityTypes: ["technology-component"],
      relationshipTypes: ["owns"],
    },
    {
      key: "organization_owns_objective_reverse",
      label: "What objectives does this own?",
      direction: "outgoing",
      relatedEntityTypes: ["objective"],
      relationshipTypes: ["owns"],
    },
    {
      key: "organization_uses_application",
      label: "Which applications does this use?",
      direction: "outgoing",
      relatedEntityTypes: ["application"],
      relationshipTypes: ["uses", "utilizes", "consumes"],
    },
    {
      key: "organization_owns_initiatives",
      label: "What initiatives does this own?",
      direction: "outgoing",
      relatedEntityTypes: ["initiative"],
      relationshipTypes: ["owns"],
    },
    {
      key: "organization_related_business_contexts",
      label: "Which business contexts is this connected to?",
      direction: "outgoing",
      relatedEntityTypes: ["business-context"],
      relationshipTypes: ["owns", "linked", "associated_with", "supports", "affects"],
      icon: "🏛️",
    },
  ],
  provider: [
    {
      key: "technology_component_offered_by_provider",
      label: "Which technology components are offered by this provider?",
      direction: "either",
      relatedEntityTypes: ["technology-component"],
      relationshipTypes: [
        "provides",
        "offers",
        "supplies",
        "owns",
        "ownership",
      ],
    },
    {
      key: "provider_supports_initiative",
      label: "Which initiatives are supported by this provider?",
      direction: "outgoing",
      relatedEntityTypes: ["initiative"],
      relationshipTypes: [
        "supports",
        "provides",
        "serves",
        "owns",
        "ownership",
      ],
    },
  ],
  objective: [
    {
      key: "objective_owned_by_organization",
      label: "Which organizations own this objective?",
      direction: "incoming",
      relatedEntityTypes: ["organization"],
      relationshipTypes: ["owns", "owned by", "ownership"],
      icon: "🏢",
    },
    {
      key: "objective_supported_by_initiative",
      label: "Which initiatives support this objective?",
      direction: "incoming",
      relatedEntityTypes: ["initiative"],
      relationshipTypes: ["supports"],
      icon: "🚀",
    },
    {
      key: "objective_improves_business_capability",
      label: "Which business capabilities are improved by this objective?",
      direction: "outgoing",
      relatedEntityTypes: ["business-capability"],
      relationshipTypes: ["improves", "supports", "enables"],
      icon: "💪",
    },
    {
      key: "objective_supported_by_platform",
      label: "Which platforms support this objective?",
      direction: "incoming",
      relatedEntityTypes: ["platform"],
      relationshipTypes: ["supports"],
      icon: "🏗️",
    },
  ],
  "business-context": [
    {
      key: "business_context_associated_with_business_capability",
      label: "Which business capabilities is this business context associated with?",
      direction: "outgoing",
      relatedEntityTypes: ["business-capability"],
      relationshipTypes: ["associated_with", "linked", "links"],
      icon: "💪",
    },
    {
      key: "initiative_affects_business_context_reverse",
      label: "Which initiatives affect this business context?",
      direction: "incoming",
      relatedEntityTypes: ["initiative"],
      relationshipTypes: ["affects", "impacts"],
    },
    {
      key: "application_supports_business_context_reverse",
      label: "Which applications support this business context?",
      direction: "incoming",
      relatedEntityTypes: ["application"],
      relationshipTypes: ["supports", "enables"],
    },
    {
      key: "business_capability_linked_to_business_context_reverse",
      label: "Which business capabilities are linked to this business context?",
      direction: "incoming",
      relatedEntityTypes: ["business-capability"],
      relationshipTypes: ["linked", "associated_with", "links"],
    },
    {
      key: "organization_owns_business_context_reverse",
      label: "Which organizations own this business context?",
      direction: "incoming",
      relatedEntityTypes: ["organization"],
      relationshipTypes: ["owns"],
    },
  ],
  "business-capability": [
    {
      key: "initiative_improves_business_capability_reverse",
      label: "Which initiatives improve this business capability?",
      direction: "incoming",
      relatedEntityTypes: ["initiative"],
      relationshipTypes: ["improves", "supports", "enables"],
    },
    {
      key: "application_supports_business_capability_reverse",
      label: "Which applications support this business capability?",
      direction: "incoming",
      relatedEntityTypes: ["application"],
      relationshipTypes: ["supports", "enables"],
    },
    {
      key: "business_context_linked_to_business_capability_reverse",
      label:
        "Which business contexts are associated with this business capability?",
      direction: "incoming",
      relatedEntityTypes: ["business-context"],
      relationshipTypes: ["linked", "associated_with", "links"],
    },
    {
      key: "objective_improves_business_capability_reverse",
      label: "Which objectives are improving this business capability?",
      direction: "incoming",
      relatedEntityTypes: ["objective"],
      relationshipTypes: ["improves", "supports", "enables"],
    },
  ],
  platform: [
    {
      key: "platform_supports_objective",
      label: "Which objectives are supported by this platform?",
      direction: "outgoing",
      relatedEntityTypes: ["objective"],
      relationshipTypes: ["supports", "enables"],
    },
    {
      key: "initiative_affects_platform_reverse",
      label: "Which initiatives affect this platform?",
      direction: "incoming",
      relatedEntityTypes: ["initiative"],
      relationshipTypes: ["affects", "impacts"],
    },
    {
      key: "platform_runs_application",
      label: "Which applications run on this platform?",
      direction: "outgoing",
      relatedEntityTypes: ["application"],
      relationshipTypes: ["runs"],
    },
    {
      key: "platform_implemented_by_it_components",
      label: "Which IT Components implement this platform?",
      direction: "incoming",
      relatedEntityTypes: ["technology-component"],
      relationshipTypes: ["implements"],
    },
  ],
};
